import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Home } from './pages/home';
import { Projects } from './pages/projects';
import { TASmart } from './pages/projects/tasmart';
import { FreshFinds } from './pages/projects/freshfinds';
import { WeatherEd } from './pages/projects/weathered';
import { VirusScope } from './pages/projects/virusScope';
import { AteliersZA } from './pages/projects/ateliersza';
import { WorkWave } from './pages/projects/workWave';
import { ChickFilEh } from './pages/projects/chickFilEh';

const router = createBrowserRouter([
	{ path: "/", element: <Home /> },
	// project page
	{ path: "/project", element: <Projects /> },
	{ path: "/project/tasmart", element: <TASmart /> },
	{ path: "/project/freshfinds", element: <FreshFinds /> },
	{ path: "/project/weathered", element: <WeatherEd /> },
	{ path: "/project/virusscope", element: <VirusScope /> },
	{ path: "/project/ateliersza", element: <AteliersZA /> },
	{ path: "/project/workwave", element: <WorkWave /> },
	{ path: "/project/chickfileh", element: <ChickFilEh /> },
]);

function App() {
  return (
    <>
      <RouterProvider router={router}></RouterProvider>
    </>
  );
}

export default App;
